import React from "react";
import { RawFileBrowser } from "react-keyed-file-browser";
import {
  Table,
  TableContainer,
  TableHead,
  Paper,
  TableBody,
  Typography,
  Toolbar,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { styles } from "./styles";

class FileManager extends RawFileBrowser {
  constructor(props) {
    super(props);
  }
  render() {
    const { title, classes } = this.props;
    const browserProps = this.getBrowserProps();
    const headerProps = {
      browserProps,
      fileKey: "",
      fileCount: this.props.files.length,
    };
    let renderedFiles;

    const files = this.getFiles();
    const selectedItems = this.getSelectedItems(files);

    let header;

    let contents = this.renderFiles(files, 0);
    if (this.props.headerRenderer) {
      header = (
        <TableHead>
          <this.props.headerRenderer
            {...headerProps}
            {...this.props.headerRendererProps}
          />
        </TableHead>
      );
    }

    renderedFiles = (
      <Table aria-label="collapsible table">
        {header}
        <TableBody>{contents}</TableBody>
      </Table>
    );

    const ConfirmMultipleDeletionRenderer =
      this.props.confirmMultipleDeletionRenderer;

    return (
      <div>
        {this.props.actions}
        <div
          ref={(el) => {
            this.browserRef = el;
          }}
        >
          {this.props.showActionBar && this.renderActionBar(selectedItems)}
          {this.state.activeAction === "delete" &&
            this.state.selection.length > 1 && (
              <ConfirmMultipleDeletionRenderer
                handleDeleteSubmit={this.handleMultipleDeleteSubmit}
              />
            )}
          <Paper>
            <Toolbar className={classes.toolbarContainer}>
              <Typography
                color="inherit"
                variant="subtitle1"
                className={classes.toolbarTitle}
              >
                {title}
              </Typography>
            </Toolbar>
            <TableContainer>{renderedFiles}</TableContainer>
          </Paper>
        </div>
        {this.state.previewFile !== null && (
          <this.props.detailRenderer
            file={this.state.previewFile}
            close={this.closeDetail}
            {...this.props.detailRendererProps}
          />
        )}
      </div>
    );
  }
}
export default withStyles(styles)(FileManager);
